import TIM from 'tim-js-sdk'
import $store from '../../../store/index'
import { postNoLoading, logPost } from '../../../assets/api/index'
let createTim = 0
let timClient = {}
let uid = JSON.parse(sessionStorage.getItem('userData')) ? JSON.parse(sessionStorage.getItem('userData')).userId : ''
export const loginTim = (SDKAppID, userID, userSig, examId, callBack) => {
  let isReady = false
  // 如果im已经登录了，不再重复登录
  sessionStorage.setItem('bloom-pc-TimExamId', examId.examId)
  if (createTim === 1) return
  createTim = 1
  let options = {
    SDKAppID // 接入时需要将0替换为您的即时通信应用的 SDKAppID
  }
  timClient = TIM.create(options)
  timClient.setLogLevel(1) // release级别，SDK 输出关键信息，生产环境时建议使用 
  timClient.on(TIM.EVENT.MESSAGE_RECEIVED, function e (event) {
    callBack(event)
    try {
      const messageList = event.data
      for (let i = 0; i < messageList.length; i++) {
        let item = messageList[i]
        if (!item.payload.text) return
        let msg = JSON.parse(item.payload.text)
        if (!msg.msgType) return
        let msgType = msg.msgType
        let examId = msg.examId
        $store.commit('set_TIMExamId', examId)
        // 手机已连接
        if (msgType && msgType === 200) {
          $store.commit('set_TIMMessage', msg)
          // 手机中断
        } else if (msgType && msgType === 210) {
          if (!$store.state.test.examConfig || $store.state.test.examConfig.mobileVideo === 1) {
            $store.commit('set_TIMMessage', {...msg, data: Date.now()})
            if (examId === sessionStorage.getItem('bloom-pc-TimExamId')) postNoLoading('TEST_CONFIGMSG', {examId}, res => {})
          }
        } else if (msgType && (msgType === 201 || msgType === 202)) {
          // 迟到  取消发布
          $store.commit('nowTestStatus', msg)
        } else if (msgType && msgType === 220) {
          $store.commit('set_TIMMessage', msg)
          timClient.logout()
        } else if (msgType && msgType === 400) {
          // 聊天消息
          if (msg.chatContentType && msg.chatContentType === 2) {
            // 监考端开始广播   1 开始广播   0 关闭广播
            $store.commit('set_beginRadio', msg)
          } else {
            $store.commit('set_TIMChatRecord', msg)
          }
        } else if (msgType && msgType === 310) {
          // 获取到人脸识别结果
          $store.commit('set_faceTipDesc', msg)
        } else if (msgType && msgType === 500) {
          // 管理后台修改个人考试配置
          $store.commit('set_examConfig', msg)
        } else if (msgType && msgType === 230) {
          // 身份核验系统核验认证结果
          $store.commit('set_verificationOfIdentity', msg)
        } else if (msgType && msgType === 240) {
          // 管理端发来的提醒
          $store.commit('set_omsTips', msg)
        } else if (msgType && msgType === 700) {
          // 全体广播开始
          msg.content = 1
          $store.commit('set_beginRadio', msg)
        } else if (msgType && msgType === 600) {
          // 设备调试手机已连接
          $store.commit('set_equipmentMobile', msg)
        } else if (msgType && msgType === 720) {
          $store.commit('set_violationCount', msg.violationCount)
        } else if (msgType && msgType === 800) {
          $store.commit('set_connectObj', msg)
        }
      }
    } catch (error) {
      // console.log(error)
    }
  })
  timClient.on(TIM.EVENT.KICKED_OUT, function a (event) {
    logPost({a: 70002, c: 'IM收到被踢下线通知', r: '/', e: event, uid: userID, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
    $store.commit('set_TIMIsLoginOut', true)
    // 收到被踢下线通知
    // event.name - TIM.EVENT.KICKED_OUT
    // event.data.type - 被踢下线的原因，例如 :
    //   - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
    //   - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
    //   - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢（v2.4.0起支持）。
  })
  timClient.on(TIM.EVENT.ERROR, function b (event) {
    logPost({a: 70003, c: 'IM收到 SDK 的错误通知', r: '/', e: event, uid: userID, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
  timClient.on(TIM.EVENT.NET_STATE_CHANGE, function c (event) {
    logPost({a: 70005, c: '网络状态发生改变', r: '/', e: event, uid: userID, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
  timClient.on(TIM.EVENT.SDK_NOT_READY, function d (event) {
    if (localStorage.getItem(`${examId}${userID}updateStatus`)) {
      logPost({a: 70004, c: 'IM 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作', r: '/', e: event, uid: userID, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
    }
  })
  timClient.on(TIM.EVENT.SDK_READY, function e (event) {
    isReady = true
    if (timClient) $store.commit('set_tim', timClient)
  })
  timClient.login({userID: userID, userSig: userSig}).then(res => {
    if (isReady) $store.commit('set_tim', timClient)
    // $store.commit('set_tim', timClient)
    $store.commit('set_TIMIsLoginOut', false)
  }).catch(err => {
    logPost({a: 70001, c: 'IM登录失败', r: '/', e: err, uid: userID, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
    createTim = 0
  })
}
// 退出登录
export const logoutTim = () => {
  try {
    createTim = 0
    if (timClient && typeof timClient.destroy() === 'function') timClient.destroy()
    $store.commit('set_tim', null)
  } catch (error) {
    
  }
}
// 加入某个群组
export const  JoinGroupIM = (groupID, callBack) => {
  console.log(timClient, groupID)
  let promise = timClient.joinGroup(groupID)
  promise.then(imResponse => {
    // return imResponse
    callBack(imResponse)
  }).catch(err => {
    logPost({a: 70006, c: `加入群组${groupID.groupID}失败`, r: '/', e: err, uid, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
}
// 创建文本消息
export const createTextMessage = (to, conversationType, text, callBack) => {
  try {
    let message = timClient.createTextMessage({
      to,
      conversationType, // 消息优先级
      payload: {text}
    })
    callBack(message)
  } catch (err) {
    logPost({a: 70007, c: `创建文本消息失败，失败消息发送给：${to},内容为：${text}`, r: '/', e: err, uid, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  }
}
// 前端im发送消息
export const sendMessage = (message, callBack) => {
  let promise = timClient.sendMessage(message)
  promise.then(imResponse => {
  // 发送成功
    callBack(imResponse)
  }).catch(err => {
  // 发送失败
    callBack({...err, isSuccessImResponse: true})
    logPost({a: 70008, c: `前端im发送消息失败，消息内容：${message}`, r: '/', e: err, uid, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
}

// 获取个人资料
export const getMyProfile = (callBack) => {
  let promise = timClient.getMyProfile()
  promise.then(imResponse => {
    callBack(imResponse.data)
    console.log(imResponse.data) // 个人资料 - Profile 实例
  }).catch(err => {
    console.warn('getMyProfile error:', err) // 获取个人资料失败的相关信息
    logPost({a: 70009, c: `获取个人资料失败`, r: '/', e: err, uid, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
}

// 拉取消息列表
// conversationID： 会话Id
// nextReqMessageID: 用于分页续拉的消息 ID。第一次拉取时不要传入 nextReqMessageID，续拉时填入上次调用 getMessageList 接口返回的该字段的值。
export const getMessageList = (data, count, callBack) => {
  console.log(data, count)
  let promise = timClient.getMessageList({...data, count})
  promise.then(imResponse => {
    console.log(imResponse)
    callBack(imResponse)
  }).catch(err => {
    logPost({a: 70010, c: `拉取消息列表失败`, r: '/', e: err, uid, examId: sessionStorage.getItem('bloom-pc-TimExamId'), ua: navigator.userAgent})
  })
}



// WEBPACK FOOTER //
// ./src/components/bloom-proctor/public/createIMClient.js